import React from 'react';
import {
  View,
  StyleSheet,
} from 'react-native';
import { feedbackStrings } from '@/constants/residents/marketplaceStrings';
import { FeedbackItem } from '@/types/residents/marketplaceListing';
import { FeedbackCard } from './FeedbackCard';
import { MarketplaceEmptyState } from './MarketplaceEmptyState';
import { UnifiedModal } from '@/components/common/UnifiedModal/UnifiedModal';

interface FeedbackModalProps {
  visible: boolean;
  onClose: () => void;
  feedbackItems: FeedbackItem[];
}

export const FeedbackModal: React.FC<FeedbackModalProps> = ({
  visible,
  onClose,
  feedbackItems,
}) => {
  return (
    <UnifiedModal
      visible={visible}
      onClose={onClose}
      variant="dialog"
      title={feedbackStrings.receivedFeedback}
      scrollable
      dialogSize="default"
    >
      <View style={styles.listContent}>
        {feedbackItems.map((feedback, index) => (
          <FeedbackCard
            key={feedback.id}
            feedback={feedback}
            showDivider={index < feedbackItems.length - 1}
          />
        ))}

        {feedbackItems.length === 0 && (
          <MarketplaceEmptyState
            title={feedbackStrings.noFeedbackReceived}
            style={{ paddingVertical: 40 }}
          />
        )}
      </View>
    </UnifiedModal>
  );
};

const styles = StyleSheet.create({
  listContent: {
    paddingTop: 10,
  },
});
